import { styled } from "@mui/material";

import { DefaultText } from ".";

export const PrimaryText = styled(DefaultText)(() => ({
  color: "#5783F1",
}));
